import React, { useMemo, useRef, useState } from "react";
import { connect } from 'react-redux';
import styles from './TemplateSelect.module.scss'
import { AppHeader } from "./service/components/serviceContent/components/AppHeader";
import Button from "../../../../../../../components/ripple/Button";
import { APP_TYPES, reorderApps } from "../../../../_helpers/custom";
import { updateBodyBuilder } from "../../../../../../../redux/actions/DeploymentActions";
import { immutableArraySlice, generateRandomID, scrollToAnchor } from "../../../../../../../helpers/common";
import { wipeModalState } from "../../../../../../../redux/actions/ModalActions";
import Messages from "../../../../../../../components/Messages";
import Input from "../../../../../../../components/Input";
import {
    handleFeaturesSwitch
} from "../../../../../basic/appsIncluded/components/features/helpers/featuresActions";

function TemplateSelect({apps, bodyBuilder, dispatch}) {

    const [search, setSearch] = useState('');
    const [types, setTypes] = useState([]);

    const searchRef = useRef();

    const filtered = useMemo(() => apps.filter(a => (
        (
            !types.length
            || types.some(type => a.type === type)
        )
        &&
        (
            !search
            || !!search && (
                a.name?.toLowerCase()?.includes(search?.toLowerCase())
                || a.code?.toLowerCase()?.includes(search?.toLowerCase())
                || a.code?.toLowerCase()?.includes(search?.toLowerCase())
            )
        )
    )), [search, types]);

    const onSubmit = (app) => {

        const preset = !!Object.keys(app.custom_preset || {}).length ? app.custom_preset : {};

        const isDefaultNetwork = bodyBuilder.networks.find(n => n.name === 'default_network');

        const common = {
            ...{
                // shared_ports,
                version: app.versions?.[app.versions?.length - 1],
                network: !!isDefaultNetwork ? [isDefaultNetwork.id] : [],
                restart: 'always',
                timestamp: new Date().toISOString(),
                _id: generateRandomID(),
            },
            ...preset
        }

        if (app.type === 'feature') {
            handleFeaturesSwitch([{...app, ...common}], true);
            dispatch(wipeModalState());
            return;
        }

        let newApps = [...bodyBuilder[app.type]];

        const newApp = [{
            ...app,
            ...common,
            ...{
                cpu: !!app.cpu && !isNaN(parseFloat(app.cpu)) ? parseFloat(app.cpu).toFixed(1) : '0',
            }
        }];

        newApps = [...newApps, ...newApp];
        newApps = reorderApps(newApps);

        dispatch(updateBodyBuilder({...bodyBuilder, ...{[app.type]: newApps}}));
        dispatch(wipeModalState());
        setTimeout(() => scrollToAnchor(`app-${app._id}`, null,true, 'builder-container'), 200);
    }

    let info = null;

    // if (type === 'service') info = 'Service - typically a server application that runs in the background and lacks a GUI, such as MySQL server, NGINX server, RabbitMQ, etc.';
    // if (type === 'feature') info = 'Feature - is a companion application that can be added to the stack. It may incur additional costs or require a non-free plan.';

    return (
        <div className={styles.select}>
            <Messages messages={info ? [{message: info}] : []} className={styles.messages}/>
            <div className={styles.search} data-show={!!search?.length}>
                <Input
                    className={styles.search__input}
                    placeholder='Add from template'
                    iconLeft='fas fa-search'
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    ref={searchRef}
                />
                <Button
                    className={styles.search__clear}
                    icon='fas fa-times'
                    displayType='text'
                    onClick={() => {
                        // console.log(searchRef)
                        setSearch('');
                        searchRef.current?.focus();
                    }}
                />
            </div>
            <div className={styles.chips}>
                <i className={`fas fa-filter ${styles.chips__icon}`}/>
                <div className={styles.chips__list}>
                    {
                        APP_TYPES.map((type, index) => {
                            const selected = types.includes(type);
                            return (
                                <Button
                                    className={`${styles.chip}${selected ? ` ${styles['chip--selected']}` : ''}`}
                                    style={{paddingRight: '5px'}}
                                    title={type.charAt(0).toUpperCase() + type.slice(1)}
                                    onClick={() => {
                                        if (selected) {
                                            setTypes(immutableArraySlice(type, types))
                                        } else {
                                            setTypes([...types, ...[type]])
                                        }
                                    }}
                                    // iconRight={selected ? `fas fa-times` : undefined}
                                    iconRight={`fas fa-times`}
                                    displayType={selected ? 'contained' : 'outlined'}
                                    visuals={{
                                        height: '3rem',
                                        // colorBasic: selected ? [`var(--colorAccentBasic)`] : [`var(--colorAccentLight)`],
                                        colorBasic: [`var(--colorAccentBasic)`],
                                    }}
                                    key={index}
                                />
                            )
                        })
                    }
                </div>
            </div>
            <div>
                {
                    filtered?.map((app, index) => {
                        return (
                            <button
                                className={styles.app}
                                onClick={() => onSubmit(app)}
                                key={index}
                            >
                                <AppHeader app={app}/>
                                {/*<AppRequirements app={app}/>*/}
                            </button>
                        )
                    })
                }
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    bodyBuilder: state.deployment.bodyBuilder,
})

export default connect(mapStateToProps)(TemplateSelect)